module.exports = __webpack_public_path__ + "static/scale-model-of-aviation-trail-in-dayton-ohio-7f965d18e820711ac9610eaddf8181e7.png";